/**
 * @desc 根据roleId查询数据权限列表
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(roleId: string | number, options?: any) {
  return updateResponse(
    http(URL + `/sysRoleData/getDatasByRoleId/${roleId}`, {
      method: "GET",

      ...options,
    }),
  );
}
